/* eslint-disable max-len */
import React, {
  useState,
  useCallback,
  useContext,
  useRef,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from 'react';
import { Button, Row, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Card, CardBody, Table, CardFooter, Alert, Badge, UncontrolledTooltip } from 'reactstrap';

import { format, parseISO } from 'date-fns';
import * as Yup from 'yup';

import { AppContext } from '../../contexts/app';
import { useManager } from '../../hooks/manager';
import api from '../../services/api';
import { numberToCurrency } from '../../utils/functions';
import CustomSelectSearch from '../CustomSelectSearch';
import MoneyMaskedInput from '../MoneyMaskedInput';
import Notification from '../Notification';

// nome anterior Especialidade - alterado para TipoDeAtendimento 17/11/2023 18:20
function TipoDeAtendimento({ onSave = () => null }, ref) {
  const notificationRef = useRef();
  const { setLoading } = useContext(AppContext);
  const [validationErrors, setValidationErrors] = useState({});
  const { update, store } = useManager();
  const [showModal, setShowModal] = useState(false);
  const [addTableDatas, setAddTableDatas] = useState(true);
  const [id, setId] = useState('');
  const [nome, setNome] = useState('');
  const [cor, setCor] = useState('#007bff');
  const [isPacote, setIsPacote] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [pacotes, setPacotes] = useState([]);
  const [profissionais, setProfissionais] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [profissional, setProfissional] = useState('');
  const [cliente, setCliente] = useState('');
  // const [horas, setHoras] = useState('');
  const [valor, setValor] = useState('');
  const [valorCliente, setValorCliente] = useState('');
  const [errors, setErrors] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [checkData, setCheckData] = useState(null);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletePreviewData, setDeletePreviewData] = useState(null);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [loadingPreview, setLoadingPreview] = useState(false);

  useImperativeHandle(ref, () => ({
    show: (data, add = true) => {
      setValidationErrors({});
      setAddTableDatas(add);

      setErrors({});
      setProfissional('');
      setCliente('');
      setValor('');
      setValorCliente('');
      if (data) {
        console.log('🚀 ~ useImperativeHandle ~ data:', data);
        setId(data._id);
        setNome(data.nome);
        setCor(data?.cor || '#007bff');
        setIsPacote(data?.isPacote || false);
        setPacotes(data?.pacotes?.map((p) => ({
          _id: p._id,
          profissional: p.profissional,
          cliente: p.cliente.id,
          horas: p.horas,
          valor: p.valor,
          valorCliente: p.valorCliente,
        })) || []);
        setShowModal(true);
        return;
      }

      setId(null);
      setNome('');
      setCor('#007bff');
      setIsPacote(false);
      setPacotes([]);
      setShowModal(true);
    },
    close: () => setShowModal(false),
  }));

  useEffect(() => {
    const loadProfissionais = async () => {
      const { data = [] } = await api.get('/profissionais?limit=0');
      return data;
    };

    const loadClientes = async () => {
      const { data = [] } = await api.get('/users?limit=0');
      return data;
    };

    (async () => {
      try {
        const [profissionaisData = [], clientesData = []] = await Promise.all([
          loadProfissionais(),
          loadClientes(),
        ]);
        // console.log(profissionaisData, fornecedoresData);
        setProfissionais(profissionaisData.map((d) => ({
          value: d._id,
          label: d.name,
        })));

        setClientes(clientesData.map((d) => ({
          value: d._id,
          label: d.criancas.nome,
          cpf: d.criancas.cpf,
        })));
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  useEffect(() => {
    const fetchCheckData = async () => {
      if (showModal && id && isPacote) {
        try {
          setLoading(true);
          const { data } = await api.get(`/financeiros-pacotes/check?tipoAtendimentoId=${id}`);
          setCheckData(data);
          setIsButtonEnabled(!data?.summary?.isApplied);
          // Update pacotes with isApplied information
          if (data?.pacotes) {
            setPacotes((prevPacotes) => prevPacotes.map((pacote) => {
              // Only try to match if pacote has an _id
              if (pacote._id) {
                const pacoteData = data.pacotes.find((p) => p.pacoteId === pacote._id);
                const isApplied = pacoteData?.isApplied || false;
                return {
                  ...pacote,
                  isApplied,
                };
              }
              // For newly added packages without _id, set isApplied to false
              return {
                ...pacote,
                isApplied: false,
              };
            }));
          }
        } catch (error) {
          console.error('Error fetching check data:', error);
          setCheckData(null);
          setIsButtonEnabled(false);
        } finally {
          setLoading(false);
        }
      } else if (!showModal || !isPacote) {
        setCheckData(null);
        setIsButtonEnabled(false);
      }
    };

    fetchCheckData();
  }, [showModal, id, isPacote, setLoading]);

  const handleAddPacote = useCallback(() => {
    let hasErrors = false;
    if (!profissional) {
      hasErrors = true;
      setErrors({
        profissional: 'Informe o profissional',
      });
    }

    if (!cliente) {
      hasErrors = true;
      setErrors((prev) => ({
        ...prev,
        cliente: 'Informe o cliente',
      }));
    }

    /* if (!horas) {
      hasErrors = true;
      setErrors((prev) => ({
        ...prev,
        horas: 'Informe as horas',
      }));
    } */

    if (!valor) {
      hasErrors = true;
      setErrors((prev) => ({
        ...prev,
        valor: 'Informe o valor',
      }));
    }

    if (hasErrors) {
      return;
    }

    setErrors({});
    setPacotes((prev) => [...prev, {
      profissional,
      cliente,
      // horas,
      valorCliente,
      valor,
    }]);
    // setProfissional('');
    setCliente('');
    // setHoras('');
    setValor('');
    setValorCliente('');
  }, [profissional, cliente, valorCliente, valor]);

  const handleRemovePacote = useCallback((indexToRemove) => {
    setPacotes((prev) => prev.filter((_, index) => index !== indexToRemove));
  }, []);

  const handleDeleteClick = useCallback(async (indexToDelete) => {
    if (!id || !isPacote) {
      // If no ID or not a package, remove directly
      handleRemovePacote(indexToDelete);
      return;
    }

    setDeleteIndex(indexToDelete);
    setLoadingPreview(true);
    setShowDeleteModal(true);

    try {
      // Get pacotes without the one being deleted
      const pacotesWithoutDeleted = pacotes.filter((_, index) => index !== indexToDelete);

      // Prepare pacotes data for the API
      const pacotesData = pacotesWithoutDeleted.map((pacote) => {
        const clienteData = clientes.find((c) => c.value === pacote.cliente);
        return {
          ...pacote,
          cliente: {
            id: pacote.cliente,
            nome: clienteData?.label || '',
            cpf: clienteData?.cpf || '',
          },
        };
      });

      const { data } = await api.post(
        `/especialidades/${id}/preview-financeiros-deletion`,
        {
          pacotes: pacotesData,
          isPacote,
        },
      );

      setDeletePreviewData(data);
    } catch (error) {
      console.error('Error fetching preview data:', error);
      notificationRef.current.notify({
        message: 'Erro ao carregar preview das contas que serão excluídas',
        color: 'danger',
      });
      setDeletePreviewData({ financeiros: [], total: 0 });
    } finally {
      setLoadingPreview(false);
    }
  }, [id, isPacote, pacotes, clientes, notificationRef, handleRemovePacote]);

  const handleCancelDelete = useCallback(() => {
    setShowDeleteModal(false);
    setDeletePreviewData(null);
    setDeleteIndex(null);
  }, []);

  // Formatters for the preview table
  const tipoFormatter = useCallback((row) => {
    if (row?.tipo === 'conta-pagar') {
      return (
        <Badge className="w-100" color="danger" tag="div">
          <i className="fa-solid fa-money-bill-transfer mr-2" />
          a Pagar
        </Badge>
      );
    }

    if (row?.tipo === 'conta-receber') {
      return (
        <Badge className="w-100" color="success" tag="div">
          <i className="fa-solid fa-hand-holding-dollar mr-2" />
          a Receber
        </Badge>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`tipo-${row._id}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`tipo-${row._id}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  /*
  const atendimentoFormatter = useCallback((row) => {
    if (row?.atendimentoStatus === 'aberto') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`agendamento-${row._id}`}>
            <i className="fa-solid fa-circle text-info mr-2" />
            Em Aberto
          </span>
        </span>
      );
    }

    if (row?.atendimentoStatus === 'cancelado') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <UncontrolledTooltip target={`agendamento-${row._id}`}>
            {formattedCanceladoBy(row)}
          </UncontrolledTooltip>
          <span id={`agendamento-${row._id}`}>
            <i className="fa-solid fa-calendar-xmark text-danger mr-2" />
            Cancelado
          </span>
          <UncontrolledTooltip target={`agendamento-eye-${row._id}`}>
            {formattedCanceladoBy(row)}
          </UncontrolledTooltip>
          <i id={`agendamento-eye-${row._id}`} className="ml-2 fa-solid fa-eye text-primary" />
        </span>
      );
    }

    if (row?.atendimentoStatus === 'concluido') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span>
            <i className="fa-solid fa-circle-check text-success mr-2" />
            Concluido
          </span>
        </span>
      );
    }

    return (
      <span className="d-flex w-100 justify-content-between align-items-center">
        <span>
          <i className="fa-solid fa-exclamation-circle text-secondary mr-2" />
          Sem agendamento
        </span>
      </span>
    );
  }, [formattedCanceladoBy]); */
  /*
  const grupoFormatter = useCallback((row) => {
    if (row?.grupoNome) {
      return (
        <div className="d-flex align-items-center">
          <UncontrolledTooltip target={`nome-tipo-${row._id}`}>
            Profissional
          </UncontrolledTooltip>
          <i
            id={`nome-tipo-${row._id}`}
            className="fa-solid fa-user text-success mr-2"
          />
          {row.grupoNome}
        </div>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`nome-tipo-${row._id}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`nome-tipo-${row._id}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []); */

  const nameFormatter = useCallback((row) => {
    if (row?.profissional?.name) {
      return (
        <div className="d-flex align-items-center">
          <UncontrolledTooltip target={`nome-tipo-${row._id}`}>
            Profissional
          </UncontrolledTooltip>
          <i
            id={`nome-tipo-${row._id}`}
            className="fa-solid fa-user text-success mr-2"
          />
          {row.profissional.name}
        </div>
      );
    }

    if (row?.cliente?.nome) {
      return (
        <div className="d-flex align-items-center">
          <UncontrolledTooltip target={`nome-tipo-${row._id}`}>
            Paciente
          </UncontrolledTooltip>
          <i
            id={`nome-tipo-${row._id}`}
            className="fa-solid fa-user text-success mr-2"
          />
          {row.cliente.nome}
        </div>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`nome-tipo-${row._id}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`nome-tipo-${row._id}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  const handleSave = useCallback(() => {
    (async () => {
      try {
        if (isPacote && !pacotes.length) {
          setErrors((prev) => ({
            ...prev,
            pacote: 'Você marcou esse atendimento como pacote, mas não informou nenhum pacote, por favor, adicione pelo menos um pacote',
          }));
          return;
        }

        const pacotesData = pacotes.map((pacote) => {
          const clienteData = clientes.find((c) => c.value === pacote.cliente);
          return ({
            ...pacote,
            cliente: {
              id: pacote.cliente,
              nome: clienteData.label,
              cpf: clienteData.cpf,
            },
          });
        });

        const data = {
          nome,
          cor,
          isPacote,
          pacotes: pacotesData,
        };

        const schema = Yup.object().shape({
          nome: Yup.string().required('Informe o nome da especialidade'),
          cor: Yup.string().required('Informe a cor da especialidade'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        if (id) {
          update(id, '/especialidades', data, async (updatedData) => {
            setLoading(false);

            if (isPacote) {
              // Keep modal open for packages and refresh check data
              onSave(updatedData);
              console.log('🚀 ~ update ~ updatedData:', updatedData);

              // First, update local pacotes with the _id from updatedData
              let updatedPacotes = pacotes;
              if (updatedData?.pacotes) {
                updatedPacotes = updatedData.pacotes.map((pacote) => ({
                  _id: pacote._id,
                  profissional: pacote.profissional,
                  cliente: pacote.cliente?.id,
                  valor: pacote.valor,
                  valorCliente: pacote.valorCliente,
                }));
                setPacotes(updatedPacotes);
              }

              try {
                setLoading(true);
                const { data: refreshedCheckData } = await api.get(`/financeiros-pacotes/check?tipoAtendimentoId=${id}`);
                setCheckData(refreshedCheckData);
                setIsButtonEnabled(!refreshedCheckData?.summary?.isApplied);

                // Update pacotes with isApplied information using the updated pacotes
                if (refreshedCheckData?.pacotes) {
                  const pacotesWithStatus = updatedPacotes.map((pacote) => {
                    if (pacote._id) {
                      const pacoteData = refreshedCheckData.pacotes.find((p) => p.pacoteId === pacote._id);
                      const isApplied = pacoteData?.isApplied || false;
                      return {
                        ...pacote,
                        isApplied,
                      };
                    }
                    return {
                      ...pacote,
                      isApplied: false,
                    };
                  });
                  setPacotes(pacotesWithStatus);
                }
              } catch (checkError) {
                console.error('Error refreshing check data:', checkError);
              } finally {
                setLoading(false);
              }
            } else {
              // Close modal for non-package types
              setShowModal(false);
              onSave(updatedData);
            }
          }, () => setLoading(false), addTableDatas);
          return;
        }

        store('/especialidades', data, async (createdData) => {
          setLoading(false);

          if (isPacote) {
            // Keep modal open for packages
            onSave(createdData);
            // Note: No check data needed for new packages as they're not yet applied
            setIsButtonEnabled(true);
          } else {
            // Close modal for non-package types
            setShowModal(false);
            onSave(createdData);
          }
        }, () => setLoading(false), addTableDatas);
      } catch (err) {
        setLoading(false);
        console.log(err);
        setValidationErrors({});
        // Validation failed
        if (err instanceof Yup.ValidationError) {
          notificationRef.current.notify({
            message:
              'Por favor, preencha todos os dados necessários para salvar',
            color: 'warning',
          });
          const ve = {};
          err.inner.forEach((e) => {
            ve[e.path] = e.message;
          });
          setValidationErrors(ve);
          return;
        }

        if (err && err.response && err.response.data) {
          const { message } = err.response.data;
          notificationRef.current.notify({
            message,
            color: 'danger',
          });

          return;
        }

        notificationRef.current.notify({
          message: 'Algo inesperado aconteceu e não foi possível salvar',
          color: 'danger',
        });
      }
    })();
  }, [id, nome, cor, addTableDatas, isPacote, pacotes, clientes, update, store, onSave, notificationRef, setLoading]);

  const handleConfirmDelete = useCallback(() => {
    if (deleteIndex !== null) {
      handleRemovePacote(deleteIndex);
      setShowDeleteModal(false);
      setDeletePreviewData(null);
      setDeleteIndex(null);
      // Execute handleSave after removal
      /* setTimeout(() => {
        handleSave();
      }, 1000); */
    }
  }, [deleteIndex, handleRemovePacote, handleSave]);

  const handleApplyPacotes = useCallback(async () => {
    if (!id) {
      notificationRef.current.notify({
        message: 'ID do tipo de atendimento não encontrado',
        color: 'danger',
      });
      return;
    }

    try {
      setLoading(true);
      const response = await api.post(`/financeiros-pacotes/generate?tipoAtendimentoId=${id}`);

      if (response.data && response.data.results && response.data.results.length > 0) {
        notificationRef.current.notify({
          message: response.data.message || 'Pacotes aplicados com sucesso!',
          color: 'success',
        });

        // Refresh check data to update button state and badges
        try {
          const { data: refreshedCheckData } = await api.get(`/financeiros-pacotes/check?tipoAtendimentoId=${id}`);
          setCheckData(refreshedCheckData);
          setIsButtonEnabled(!refreshedCheckData?.summary?.isApplied);

          // Update pacotes with isApplied information
          if (refreshedCheckData?.pacotes) {
            setPacotes((prevPacotes) => prevPacotes.map((pacote) => {
              if (pacote._id) {
                const pacoteData = refreshedCheckData.pacotes.find((p) => p.pacoteId === pacote._id);
                const isApplied = pacoteData?.isApplied || false;
                return {
                  ...pacote,
                  isApplied,
                };
              }
              return {
                ...pacote,
                isApplied: false,
              };
            }));
          }
        } catch (checkError) {
          console.error('Error refreshing check data:', checkError);
        }
      }
    } catch (err) {
      console.error('Error applying pacotes:', err);

      if (err && err.response && err.response.data) {
        const { message } = err.response.data;
        notificationRef.current.notify({
          message: message || 'Erro ao aplicar pacotes',
          color: 'danger',
        });
      } else {
        notificationRef.current.notify({
          message: 'Erro ao aplicar pacotes. Tente novamente.',
          color: 'danger',
        });
      }
    } finally {
      setLoading(false);
    }
  }, [id, setLoading]);

  return (
    <>
      <Notification ref={notificationRef} />
      <Modal isOpen={showModal} toggle={() => setShowModal(!showModal)} centered size="lg">
        <ModalHeader>
          <strong>Tipo de Atendimento</strong>
          <Button
            className="close position-absolute top-4 right-4 py-1 px-2"
            onClick={() => setShowModal(false)}
          >
            <i className="fas fa-times" />
          </Button>
        </ModalHeader>
        <ModalBody>
          {isPacote && errors?.pacote && (
          <Alert color="warning">
            <p>
              <strong>Atenção:</strong>
              <br />
              <br />
              <span>
                {errors?.pacote}
              </span>
            </p>
          </Alert>
          )}
          <Form>
            <Row>
              <Col xs={12} sm={8} md={10}>
                <FormGroup>
                  <Input
                    type="text"
                    placeholder="Nome"
                    value={nome}
                    invalid={!!validationErrors.nome}
                    onChange={({ target: { value } }) => setNome(value)}
                  />
                  <FormFeedback>{validationErrors.nome}</FormFeedback>
                </FormGroup>
              </Col>
              <Col xs={12} sm={4} md={2}>
                <div className="d-flex justify-content-end align-items-center w-100 h-100 pb-3">
                  <FormGroup switch>
                    <Input
                      type="switch"
                      checked={isPacote}
                      onClick={() => setIsPacote(!isPacote)}
                    />
                    <Label check>Pacote</Label>
                  </FormGroup>
                </div>
              </Col>
            </Row>
            {/* <Form>
                <FormGroup>
                  <Input
                    type="color"
                    placeholder="Cor"
                    value={cor}
                    invalid={!!validationErrors.cor}
                    onChange={({ target: { value } }) => setCor(value)}
                  />
                  <FormFeedback>{validationErrors.cor}</FormFeedback>
                </FormGroup>
              </Form>
            */}
            {isPacote && (
              <Row>
                <Col>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label for="profissionalSelect">
                              Profissional
                            </Label>
                            <CustomSelectSearch
                              id="profissionalSelect"
                              name="profissional"
                              value={profissional}
                              onChange={(value) => setProfissional(value)}
                              options={profissionais}
                              placeholder="Selecione um Profissional"
                              invalid={!!errors?.profissional}
                              errorMessage={errors?.profissional}
                              loadingMessage="Carregando profissionais"
                              noOptionsMessage="Nenhum profissional encontrado"
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label for="clienteSelect">
                              Cliente
                            </Label>
                            <CustomSelectSearch
                              id="clienteSelect"
                              name="cliente"
                              value={cliente}
                              onChange={(value) => setCliente(value)}
                              options={clientes}
                              placeholder="Selecione um Paciente"
                              invalid={!!errors?.cliente}
                              errorMessage={errors?.cliente}
                              loadingMessage="Carregando pacientes"
                              noOptionsMessage="Nenhum paciente encontrado"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <MoneyMaskedInput
                            label="Valor Profissional"
                            name="valor"
                            invalidMessage={errors?.valor}
                            value={valor}
                            onValueChange={({ floatValue }) => setValor(floatValue)}
                          />
                        </Col>
                        <Col>
                          <MoneyMaskedInput
                            label="Valor Cliente"
                            name="valorCliente"
                            invalidMessage={errors?.valorCliente}
                            value={valorCliente}
                            onValueChange={({ floatValue }) => setValorCliente(floatValue)}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-end">
                      <Button color="primary" size="sm" onClick={handleAddPacote}>Adicionar</Button>
                    </CardFooter>
                  </Card>
                  <Table>
                    <thead>
                      <tr>
                        <th>Profissional</th>
                        <th>Paciente</th>
                        <th>Valor</th>
                        <th>Valor Cliente</th>
                        <th>Status</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pacotes.map((pacote, index) => {
                        const profissionalData = profissionais.find((p) => p.value === pacote.profissional);
                        const clienteData = clientes.find((c) => c.value === pacote.cliente);
                        return (
                          <tr key={`pacote${pacote.id}-${index}`}>
                            <td>{profissionalData?.label}</td>
                            <td>{clienteData?.label}</td>
                            <td>{numberToCurrency(pacote?.valor || 0)}</td>
                            <td>{numberToCurrency(pacote?.valorCliente || 0)}</td>
                            <td>
                              <span className={`badge ${pacote?.isApplied ? 'bg-success' : 'bg-warning'}`}>
                                {pacote?.isApplied ? 'Aplicado' : 'Pendente'}
                              </span>
                            </td>
                            <td>
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => handleDeleteClick(index)}
                              >
                                <i className="fas fa-trash" />
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            )}
          </Form>
        </ModalBody>
        <ModalFooter className="d-flex flex-column">
          <div>
            {isPacote && !isButtonEnabled && (
              <div className="text-danger mb-2" style={{ fontSize: '0.875rem' }}>
                <strong>Atenção:</strong>
                {' '}
                A rotina de geração de pacotes já foi aplicada. Para qualquer alteração ou inclusão de novos pacotes deve clicar no botão &apos;Aplicar Agora&apos;.
              </div>
            )}
          </div>
          <div className="d-flex w-100 justify-content-between">
            {isPacote && (
              <Button
                color={!isButtonEnabled ? 'dark' : 'primary'}
                className={!isButtonEnabled ? 'opacity-3' : ''}
                onClick={handleApplyPacotes}
                disabled={!isButtonEnabled}
              >
                Aplicar Agora
              </Button>
            )}
            <Button color="primary" onClick={handleSave}>Salvar</Button>
          </div>
        </ModalFooter>
      </Modal>

      {/* Modal de Confirmação de Exclusão */}
      <Modal isOpen={showDeleteModal} toggle={handleCancelDelete} centered size="lg">
        <ModalHeader>
          <strong>Confirmar Exclusão de Pacote</strong>
          <Button
            className="close position-absolute top-4 right-4 py-1 px-2"
            onClick={handleCancelDelete}
          >
            <i className="fas fa-times" />
          </Button>
        </ModalHeader>
        <ModalBody>
          {loadingPreview ? (
            <div className="text-center p-4">
              <i className="fa-solid fa-spinner fa-spin fa-2x text-primary" />
              <p className="mt-2">Carregando preview das contas...</p>
            </div>
          ) : (
            <>
              <Alert color="warning" className="mb-3">
                <strong>Atenção:</strong>
                {' '}
                {deletePreviewData?.total === 0 ? 'Nenhuma conta será afetada pela exclusão deste pacote.' : 'Ao confirmar as contas abaixo serão excluídas permanentemente. Deseja realmente continuar?'}
              </Alert>

              {deletePreviewData?.total === 0 ? (
                <div className="text-center p-4">
                  <i className="fa-solid fa-check-circle fa-2x text-success" />
                  <p className="mt-2 text-success">
                    <strong>Nenhuma conta será afetada pela exclusão deste pacote.</strong>
                  </p>
                </div>
              ) : (
                <>
                  <div className="mb-3">
                    <strong>
                      Total de contas que serão excluídas:
                      {' '}
                      {deletePreviewData?.total || 0}
                    </strong>
                  </div>
                  <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <Table striped hover size="sm">
                      <thead>
                        <tr>
                          <th style={{ width: '120px' }}>Módulo</th>
                          {/* <th style={{ width: '150px' }}>Atendimento</th> */}
                          {/* <th style={{ width: '150px' }}>Grupo</th> */}
                          <th style={{ width: '300px' }}>Profissional/Paciente</th>
                          {/* <th style={{ width: '150px' }}>Mês do Atendimento</th> */}
                          <th style={{ width: '130px' }}>Data Atendimento</th>
                          {/* <th style={{ width: '200px' }}>Tipo</th>
                          <th style={{ width: '300px' }}>Empresa Pagante</th> */}
                          <th style={{ width: '150px' }}>Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        {deletePreviewData?.financeiros?.map((row, index) => (
                          <tr key={row._id || index}>
                            <td className="text-center">
                              {tipoFormatter(row)}
                            </td>
                            {/* <td className="text-center">
                              {atendimentoFormatter(row)}
                            </td>
                            <td>
                              {grupoFormatter(row)}
                            </td> */}
                            <td>
                              {nameFormatter(row)}
                            </td>
                            {/* <td className="text-center">
                              {row.mes && row.ano ? (() => {
                                const mesNum = parseInt(row.mes, 10);
                                if (Number.isNaN(mesNum)) return '-';
                                const month = months.find((m) => m.value === mesNum);
                                return month ? `${month.label}/${row.ano}` : 'Inválido';
                              })() : '-'}
                            </td> */}
                            <td>
                              {row.startAtendimentoDate ? (() => {
                                try {
                                  return format(parseISO(row.startAtendimentoDate), 'dd/MM/yyyy');
                                } catch (err) {
                                  return 'Data Inválida';
                                }
                              })() : 'Sem Data'}
                            </td>
                            {/* <td className="text-center">
                              {row.tipoLancamento || '-'}
                            </td>
                            <td>
                              {row.razaoSocial ? `${row.razaoSocial} (${row.cnpj || ''})` : '-'}
                            </td> */}
                            <td>
                              {row?.tipoLancamento === 'REEMBOLSO'
                                ? numberToCurrency(row?.valorReembolso || 0)
                                : numberToCurrency(row?.valor || 0)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </>
              )}
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleConfirmDelete} disabled={loadingPreview}>
            Confirmar Exclusão
          </Button>
          <Button color="secondary" onClick={handleCancelDelete} disabled={loadingPreview}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default forwardRef(TipoDeAtendimento);
